import { useEffect, useState } from 'react';

/**
 * Trails `value` by `delay` milliseconds. Used where a value drives a request
 * but changes on every keystroke — the request should follow the pause, not the
 * typing.
 */
export function useDebouncedValue<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
